import * as GetProjectTypes from 'src/actions/project/get/Types';
import { GetProjectAction, GetProjectSuccess } from 'src/actions/project/get/GetProject.actions';
import Project from 'src/entities/Project';

export interface GetProjectState {
  project?: Project;
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: GetProjectState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function GetProjectReducer(
  state: GetProjectState = initialState,
  action: GetProjectAction
): GetProjectState {

    switch (action.type) {
        case GetProjectTypes.GET_PROJECT_ATTEMPT:
            return {...state, project: undefined, loading: true, error: false};
        case GetProjectTypes.GET_PROJECT_SUCCESS:
            const project: Project = (action as GetProjectSuccess).payload;
            return {...state, project: project, loading: false, error: false};
        case GetProjectTypes.GET_PROJECT_FAILURE:
            return {...state, project: undefined, loading: false, error: true};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/project/GetProjectReducer.tsx